import React from 'react';

export const QuestionarioCasasStepThree = ({ formData, handleChange }) => {
  return (
    <div className="space-y-4" data-testid="questionario-casas-step-3">
      {formData.serviceCategory === 'casas' && (
        <>
          <select name="propertyGoal" value={formData.propertyGoal} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-property-goal-select">
            <option value="">Objetivo com imóvel *</option>
            <option value="comprar-morar">Comprar para morar</option>
            <option value="investimento">Investimento</option>
            <option value="troca-imovel">Trocar de imóvel</option>
          </select>
          <input type="text" name="preferredArea" value={formData.preferredArea} onChange={handleChange} required placeholder="Área/cidade de interesse *" className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-preferred-area-input" />
          <select name="budgetRange" value={formData.budgetRange} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-budget-range-select">
            <option value="">Faixa de orçamento *</option>
            <option value="ate-20m">Até ¥20.000.000</option>
            <option value="20m-30m">¥20.000.000 ~ ¥30.000.000</option>
            <option value="30m-50m">¥30.000.000 ~ ¥50.000.000</option>
            <option value="acima-50m">Acima de ¥50.000.000</option>
          </select>
          <select name="financingStatus" value={formData.financingStatus} onChange={handleChange} className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-financing-status-select">
            <option value="">Situação de financiamento</option>
            <option value="aprovado">Já aprovado</option>
            <option value="em-analise">Em análise</option>
            <option value="precisa-orientacao">Preciso de orientação</option>
          </select>
        </>
      )}

      {formData.serviceCategory === 'reforma' && (
        <>
          <select name="reformType" value={formData.reformType} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-reform-type-select">
            <option value="">Tipo de reforma *</option>
            <option value="interna">Interna</option>
            <option value="externa">Externa</option>
            <option value="completa">Completa</option>
            <option value="comercial">Comercial</option>
          </select>
          <select name="reformPropertyType" value={formData.reformPropertyType} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-reform-property-type-select">
            <option value="">Tipo do imóvel *</option>
            <option value="casa">Casa</option>
            <option value="apartamento">Apartamento</option>
            <option value="loja">Loja / comércio</option>
            <option value="galpao">Galpão</option>
          </select>
          <select name="reformTimeline" value={formData.reformTimeline} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-reform-timeline-select">
            <option value="">Prazo desejado *</option>
            <option value="imediato">Imediato</option>
            <option value="30-dias">Em até 30 dias</option>
            <option value="90-dias">Em até 90 dias</option>
            <option value="sem-pressa">Sem pressa</option>
          </select>
        </>
      )}

      {formData.serviceCategory === 'painel_solar' && (
        <>
          <select name="solarPropertyType" value={formData.solarPropertyType} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-solar-property-type-select">
            <option value="">Tipo do imóvel *</option>
            <option value="casa">Casa</option>
            <option value="comercio">Comércio</option>
            <option value="industria">Indústria</option>
          </select>
          <select name="monthlyEnergyBill" value={formData.monthlyEnergyBill} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-monthly-energy-bill-select">
            <option value="">Conta média de energia *</option>
            <option value="ate-15000">Até ¥15.000</option>
            <option value="15000-30000">¥15.000 ~ ¥30.000</option>
            <option value="30000-50000">¥30.000 ~ ¥50.000</option>
            <option value="acima-50000">Acima de ¥50.000</option>
          </select>
          <select name="solarGoal" value={formData.solarGoal} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-solar-goal-select">
            <option value="">Objetivo principal *</option>
            <option value="economia">Reduzir conta de luz</option>
            <option value="sustentabilidade">Sustentabilidade</option>
            <option value="autonomia">Maior autonomia energética</option>
          </select>
          <select name="hasBatteryInterest" value={formData.hasBatteryInterest} onChange={handleChange} className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-battery-interest-select">
            <option value="">Interesse em bateria?</option>
            <option value="sim">Sim</option>
            <option value="nao">Não</option>
            <option value="talvez">Talvez</option>
          </select>
        </>
      )}
    </div>
  );
};
